import { Box, Chip } from "@mui/material";

const CategoryFilters = ({
  categories,
  onChipClick,
}: {
  categories: string[];
  onChipClick: (category: string) => void;
}) => (
  <Box sx={{ display: "flex", gap: 3, overflow: "auto" }}>
    {categories.map((cat) => (
      <Chip
        key={cat}
        label={cat}
        onClick={() => onChipClick(cat)}
        sx={
          cat !== "All categories"
            ? { backgroundColor: "transparent", border: "none" }
            : undefined
        }
      />
    ))}
  </Box>
);

export default CategoryFilters;
